// Simple Flex Box Container that supports all the basic Flex-box properties
import { CSSProperties } from "react";
import styled from "styled-components";

import type { SimpleGridProps } from "@vfuk/core-simple-grid/dist/SimpleGrid.types";

export interface StackProps {
  direction?: "row" | "column";
  align?: CSSProperties["alignItems"];
  spacing?: SimpleGridProps["spacing"];
  justifyContent?: CSSProperties["justifyContent"];
  width?: CSSProperties["width"];
  columnGap?: CSSProperties["columnGap"];
  rowGap?: CSSProperties["rowGap"];
  height?: CSSProperties["height"];
  flexWrap?: CSSProperties["flexWrap"];
}

const Stack = styled.div<StackProps>`
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  align-items: ${(props) => props.align || "center"};
  justify-content: ${(props) => props.justifyContent || "normal"};
  width: ${(props) => props.width || "auto"};
  column-gap: ${(props) => props.columnGap};
  row-gap: ${(props) => props.rowGap};
  height: ${(props) => props.height};
  flex-wrap: ${(props) => props.flexWrap || "unset"};
`;

export default Stack;
